<template>
  <NuxtPage
    :auth-route-name="CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.AUTH"
    @exit-to-cart="navigateTo({ name: CHECKOUT_E_COMMERCE.CART })"
    @exit-to-continue-shopping="navigateTo({ name: HOME })"
    @exit-to-payment="
      navigateToPaymentPage({ name: CHECKOUT_E_COMMERCE.PAYMENT })
    "
    @go-to-auth="
      navigateTo({ name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.AUTH })
    "
    @go-to-not-eligible="
      navigateTo({ name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.NOT_ELIGIBLE })
    "
    @go-to-phoneline-setup="
      (accessToken: string) =>
        navigateTo({
          name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.PHONELINE_SETUP,
          query: { accessToken },
        })
    "
    @go-to-sign-up="
      navigateTo({ name: CHECKOUT_E_COMMERCE.SERVICES.BOUYGUES.SIGN_UP })
    "
  />
</template>

<script setup lang="ts">
import { navigateTo } from '#imports'

import { navigateToPaymentPage } from '@backmarket/nuxt-layer-payment/pages/navigateToPaymentPage'

import { HOME } from '~/scopes/home/route-names'

import { CHECKOUT_E_COMMERCE } from '../../route-names'
</script>
